import { GetterTree } from 'vuex'

import { QA_STATUS } from '@/common/utils/qa-status'
import { Question } from '@/types/qa'

import { QuestionAnswerState } from './state'

export const QA_HIDDEN_AUTHOR_KEY = 'QA_HIDDEN_AUTHOR_KEY'

export const getters: GetterTree<QuestionAnswerState, any> = {
  questions: state => state.questions?.questions ?? [],
  questioners: (_state, getters, rootState, rootGetters) => {
    const questions: Question[] = getters.questions ?? []

    const unique = (arr: Array<string | undefined>) =>
      [...new Set(arr.filter((v): v is string => Boolean(v)))]

    const currentUserId = rootGetters['user/currentUserId']
    const isCurrentUserPm = rootGetters['room/isCurrentUserPm']
    const hideQaAuthors = Boolean(rootState.room?.currentRoom?.hideQaAuthors)

    // PM or hideQaAuthors off: return all unique names
    if (isCurrentUserPm || !hideQaAuthors) {
      return unique(questions.map((q: Question) => q.userName))
    }

    // Guests and hideQaAuthors on: return only "me" and "Auteur masqué"
    const myName = questions.find((q: Question) => q.userId === currentUserId)?.userName

    return unique([myName, QA_HIDDEN_AUTHOR_KEY])
  },
  awaitingQuestions: (_, getters) => getters.questions.filter((question: Question) => question.status === QA_STATUS.TO_ANSWER),
  awaitingAnswers: (_, getters) => getters.questions.filter((question: Question) => question.status === QA_STATUS.TO_VALIDATE),
  validatedQuestions: (_, getters) => getters.questions.filter((question: Question) => question.status === QA_STATUS.VALIDATED),
  counterAwaitingQuestions: (_, getters) => getters.awaitingQuestions.length,
  counterAwaitingAnswers: (_, getters) => getters.awaitingAnswers.length,
  counterValidatedQuestions: (_, getters) => getters.validatedQuestions.length,
  counterAllQuestions: (_, getters) => getters.questions.length,
  categoriesAsObject: state => state.categories?.reduce((result, current :{id:number, name:string}) => ({ ...result, [current.id]: current.name }), {}),
}
